<button class="chat-fab btn btn-primary btn-icon" type="button"
  [attr.aria-label]="chatState.open() ? 'Close chat' : (chatState.unreadCount() > 0 ? 'Open chat, ' + chatState.unreadCount() + ' unread messages' : 'Open chat')"
  [attr.aria-expanded]="chatState.open()" aria-controls="global-chat-panel" (click)="toggle()">
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.8214 2.48697 15.5291 3.33782 17L2.5 21.5L7 20.6622C8.47087 21.513 10.1786 22 12 22Z"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  <span class="chat-unread badge bg-danger text-danger-fg" *ngIf="chatState.unreadCount() > 0">{{
    chatState.unreadCount() > 99 ? '99+' : chatState.unreadCount() }}</span>
</button>

<section id="global-chat-panel" class="chat-panel chat-widget-popover card" *ngIf="chatState.open()" role="dialog"
  aria-label="Chat">


  <div class="alert alert-danger m-2" role="alert" *ngIf="chatState.error()">
    {{ chatState.error() }}
  </div>

  <div class="chat-layout" [class.chat-layout-list]="showConversationList">
    <aside class="chat-sidebar border-end" *ngIf="showConversationList">
      <header class="chat-list-header d-flex align-items-center justify-content-between gap-2 p-2 border-bottom">
        <div class="row w-100 g-1">
            <div class="col">

              <div class="input-icon mb-1">
                <input type="text" value="" class="form-control form-control-rounded" type="search" placeholder="Find a colleague"
                  aria-label="Find a colleague" [ngModel]="chatState.userSearch()"
                  [ngModelOptions]="{ standalone: true }" (ngModelChange)="searchUsers($event)">
                <span class="input-icon-addon">
                  <!-- Download SVG icon from http://tabler.io/icons/icon/search -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    aria-hidden="true" focusable="false" class="icon">
                    <path d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                    <path d="M21 21l-6 -6"></path>
                  </svg>
                </span>
              </div>


            </div>
          <div class="col-auto">
            <button type="button" class="btn btn-icon btn-ghost-secondary btn-pill" aria-label="Minimize chat" title="Minimize"
              (click)="chatState.close()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="currentColor"
                class="icon icon-tabler icons-tabler-filled icon-tabler-chevron-down" aria-hidden="true">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M18.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1 -1.414 0l-6 -6a1 1 0 0 1 1.414 -1.414l5.293 5.293l5.293 -5.293a1 1 0 0 1 1.414 0" />
              </svg></button>

          </div>
        </div>

      </header>


      <div class="chat-list list-group list-group-flush overflow-auto"
        *ngIf="chatState.userSearch(); else conversationList">
        <div class="list-group-item" *ngFor="let user of chatState.userResults()" (click)="startConversation(user.id)">
          <div class="row">
            <div class="col-auto">
              <span class="avatar avatar-sm overflow-hidden">{{ user.display_name.slice(0, 1).toUpperCase() }}</span>
            </div>
            <div class="col text-truncate">

              <a class="text-body d-block">{{ user.display_name }}</a>
              <div class="text-secondary text-truncate mt-n1">{{ user.email }}</div>
            </div>
          </div>
        </div>
        <div class="empty py-4" *ngIf="chatState.userResults().length === 0">
          <p class="empty-title mb-0">No people found</p>
        </div>
      </div>

      <ng-template #conversationList>
        <div class="chat-list list-group list-group-flush overflow-auto">
          <div class="chat-list-item list-group-item" *ngFor="let conversation of chatState.conversations()"
            [class.active]="chatState.activeConversationId() === conversation.id"
            (click)="openConversation(conversation.id)">
            <div class="row">
              <div class="col-auto">
                <span class="avatar ">{{ chatState.conversationLabel(conversation).slice(0,
                  1).toUpperCase() }}
                  <span class="badge bg-danger text-danger-fg" *ngIf="conversation.unread_count > 0">{{
                    conversation.unread_count > 99 ? '99+' : conversation.unread_count }}</span>
                </span>
              </div>

              <div class="col text-truncate">
                <span class="text-body d-block">{{ chatState.conversationLabel(conversation) | titlecase }}</span>
                <span class="text-secondary text-truncate mt-n1">{{ conversation.last_message?.content || 'No messages yet' }}</span>
              </div>


            </div>
          </div>
          <div class="empty py-4" *ngIf="!chatState.loading() && chatState.conversations().length === 0">
            <p class="empty-title mb-1">No conversations yet</p>
            <p class="empty-subtitle">Search for a colleague to start chatting.</p>
          </div>
        </div>
      </ng-template>
    </aside>

    <div class="chat-main" *ngIf="!showConversationList">
      <header class="card-header p-2">
        <div class="d-flex align-items-center justify-content-between w-100 gap-2">
          <div class="min-width-0">
            <div class="d-flex align-items-center gap-2 min-width-0">
              <button type="button" class="btn btn-icon btn-pill btn-ghost-secondary chat-back-button"
                aria-label="Back to conversations" title="Back to conversations" (click)="backToConversationList()"><svg
                  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left" aria-hidden="true">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 12l14 0" />
                  <path d="M5 12l4 4" />
                  <path d="M5 12l4 -4" />
                </svg><span class="chat-back-unread badge bg-danger text-danger-fg"
                  *ngIf="chatState.unreadCount() > 0">{{ chatState.unreadCount() > 99 ? '99+' : chatState.unreadCount()
                  }}</span></button>
              <h3 class="card-title mb-0 text-truncate">{{ chatState.activeConversation() ?
                chatState.conversationLabel(chatState.activeConversation()!) : 'Chat' }}</h3>
              <span class="badge bg-danger text-danger-fg flex-shrink-0" *ngIf="chatState.unreadCount() > 0">{{
                chatState.unreadCount() > 99 ? '99+' : chatState.unreadCount() }}</span>
            </div>

          </div>
          <button type="button" class="btn btn-icon btn-pill btn-ghost-secondary" aria-label="Minimize chat" title="Minimize"
            (click)="chatState.close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
              class="icon icon-tabler icons-tabler-filled icon-tabler-chevron-down" aria-hidden="true">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M18.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1 -1.414 0l-6 -6a1 1 0 0 1 1.414 -1.414l5.293 5.293l5.293 -5.293a1 1 0 0 1 1.414 0" />
            </svg>
          </button>
        </div>
      </header>
      <a *ngIf="chatState.activeConversation() as active"
        [hidden]="!active.business_document_id || !active.business_document_route"
        class="alert alert-info rounded-0 m-0 d-flex align-items-center gap-2 text-decoration-none"
        [routerLink]="active.business_document_route">
        <i class="ti ti-file-description" aria-hidden="true"></i>
        <span><strong>Business document</strong><span class="d-block small">Open the document linked to this group
            chat.</span></span>
        <i class="ti ti-chevron-right ms-auto" aria-hidden="true"></i>
      </a>
      <div class="chat-thread" *ngIf="chatState.activeConversationId(); else emptyThread">
        <ng-container *ngFor="let group of messageGroups(); trackBy: trackGroup">
          <div class="chat-date-divider" *ngIf="group.showDate"><span>{{ group.date }}</span></div>
          <section class="chat-message-group" [class.chat-message-own]="chatState.isOwnMessage(group.messages[0])">
            <div class="chat-sender text-secondary small">{{ chatState.isOwnMessage(group.messages[0]) ? 'You' :
              group.messages[0].sender.display_name }}</div>
            <article class="chat-message"
              *ngFor="let messageItem of group.messages; let first = first; trackBy: trackMessage"
              [class.chat-message-first]="first">
              <div class="chat-bubble" [title]="groupTime(messageItem)">
                <span class="fst-italic text-secondary" *ngIf="messageItem.deleted_at">Message deleted</span>
                <ng-container *ngIf="!messageItem.deleted_at">
                  <div *ngIf="messageItem.content">{{ messageItem.content }}</div>
                  <button type="button" class="chat-attachment btn btn-sm"
                    *ngFor="let attachment of messageItem.attachments"
                    (click)="chatState.openAttachment(attachment.id)">
                    <span>{{ attachment.file_name }}</span>
                    <span class="small text-secondary">{{ attachment.content_type.startsWith('image/') ? 'Image' :
                      attachment.content_type.startsWith('audio/') ? 'Audio' :
                      attachment.content_type.startsWith('video/') ? 'Video' : 'Document' }} · {{
                      fileSize(attachment.size_bytes) }} ↗</span>
                  </button>
                </ng-container>
              </div>
              <span class="chat-receipt" *ngIf="chatState.isOwnMessage(messageItem) && !messageItem.deleted_at"
                [class.chat-receipt-read]="chatState.deliveryStatus(messageItem) === 'Read'"
                [attr.aria-label]="chatState.deliveryStatus(messageItem)"
                [title]="chatState.deliveryStatus(messageItem)" role="img">
                <svg width="20" height="16" viewBox="0 0 24 18" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M3 9l4 4L17 3" />
                  <path *ngIf="chatState.deliveryStatus(messageItem) !== 'Sent'" d="M12 12l1 1L23 3" />
                </svg>
              </span>
            </article>
            <div class="chat-group-time text-secondary small">{{ groupTime(group.messages[group.messages.length - 1]) }}
            </div>
          </section>
        </ng-container>
      </div>

      <ng-template #emptyThread>
        <div class="empty h-100 d-flex flex-column justify-content-center">
          <div class="empty-icon text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
              aria-hidden="true">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 9h8" />
              <path d="M8 13h6" />
              <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12" />
            </svg>
          </div>
          <p class="empty-title">Choose a conversation</p>
        </div>
      </ng-template>

      <footer class="chat-composer border-top" *ngIf="chatState.activeConversationId()">
        <div class="d-flex flex-wrap gap-1 mb-2" *ngIf="chatState.pendingAttachments().length">
          <span class="badge bg-secondary-lt d-flex align-items-center gap-1"
            *ngFor="let attachment of chatState.pendingAttachments()">
            {{ attachment.file_name }}
            <button type="button" class="btn-close btn-close-sm" aria-label="Remove attachment"
              (click)="chatState.removePendingAttachment(attachment.object_key)"></button>
          </span>
        </div>
        <div class="text-secondary small mb-2" role="status" *ngIf="chatState.uploading()">Uploading file… Please wait
          before sending.</div>
        <div class="chat-composer-shell">
          <input #attachmentPicker type="file" class="visually-hidden" (change)="attach($event)"
            [disabled]="chatState.uploading() || chatState.sending()" />
          <button cdkOverlayOrigin #attachmentOrigin="cdkOverlayOrigin" type="button"
            class="chat-composer-icon btn btn-icon" [disabled]="chatState.uploading() || chatState.sending()"
            aria-label="Attach a file" aria-haspopup="menu" [attr.aria-expanded]="attachmentMenuOpen"
            (click)="attachmentMenuOpen = !attachmentMenuOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-plus" aria-hidden="true">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 5l0 14" />
              <path d="M5 12l14 0" />
            </svg>
          </button>
          <app-floating-dropdown [origin]="attachmentOrigin" [open]="attachmentMenuOpen"
            (openChange)="attachmentMenuOpen = $event" align="start" panelClass="p-1 shadow" minWidth="13rem">
            <button type="button" class="dropdown-item"
              (click)="chooseAttachment(attachmentPicker, 'image/*,video/*')">Photos &amp; videos</button>
            <button type="button" class="dropdown-item"
              (click)="chooseAttachment(attachmentPicker, 'audio/*')">Audio</button>
            <button type="button" class="dropdown-item" (click)="chooseAttachment(attachmentPicker, '')">Document /
              other file</button>
          </app-floating-dropdown>
          <input class="form-control" placeholder="Write a message" aria-label="Message" [(ngModel)]="message"
            [ngModelOptions]="{ standalone: true }" (keydown.enter)="send()" />
          <button type="button" class="chat-submit btn btn-primary" aria-label="Send message" title="Send message"
            [disabled]="chatState.sending() || chatState.uploading() || (!message.trim() && !chatState.pendingAttachments().length)"
            (click)="send()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-0"
              aria-hidden="true">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M4.698 4.034l16.302 7.966l-16.302 7.966a.503 .503 0 0 1 -.546 -.124a.555 .555 0 0 1 -.12 -.568l2.468 -7.274l-2.468 -7.274a.555 .555 0 0 1 .12 -.568a.503 .503 0 0 1 .546 -.124" />
              <path d="M6.5 12h14.5" />
            </svg>
          </button>
        </div>
      </footer>
    </div>
  </div>
</section>